var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsersComponent',{attrs:{"loading":!_vm.usersLoaded,"users":_vm.users,"componentType":_vm.componentType}})
}
var staticRenderFns = []

export { render, staticRenderFns }